function currencyFormat(val, currSymbol)
{
	if(typeof currSymbol === 'undefined')
		currSymbol = '£';
	
	val = val.toFixed(2);

	val = currSymbol + val;

	return val;
}